import type { FaireProductEntity } from "../../entity_types/product";

export const p_vgceg4wuas: FaireProductEntity = {
  token: "p_vgceg4wuas",
  type: "product",
  name: "Daddy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/640197ffde363555f70fabd38acdb482ff86bb54989be77bcd13d875b4a61591.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3aabf0f25c4136b461106d30dc7c589c8184002b55c9448e3c7e9e6eb012df8.jpeg",
    "https://cdn.faire.com/fastly/47397310fbcbae8a740abc438d2926d28b65d3cedcab38fd5d278c8c19503009.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/1c432aaaf1556ea10b5d78149de9345d29844de1538ed5439ec45fd53e672726.jpeg",
    "https://cdn.faire.com/fastly/10993c66d6846ab22f54756949f4d3b5b412c3680477fbf3a9320de2c4fbbe96.jpeg",
    "https://cdn.faire.com/fastly/21cdfa1301eb093b16247e834c48e414be8c3ddfcdb061886f1dec18eb04bc6c.jpeg",
    "https://cdn.faire.com/fastly/18e7766d4ab7074a53f7c3572c6e7f1100d01aa487ebdd020364115e7e02744b.jpeg",
    "https://cdn.faire.com/fastly/824f9de01f8ea72c895f0d627a2035799a4978b2522637ce8aa9ad0e7caba9c2.jpeg"
  ],
  priceDollars: 6.75,
  description: "Welcome to your new socks, DADDY! Skip the chaos and cut to the vibe—these babies say it all, with no added responsibilities. Pairs well with raw sexual magnetism and a self-assured smirk. 😏\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:08.105Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
